import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ContactType } from 'src/app/kuba/contact/models/contactView';
import { Observable } from 'rxjs';

import { Client } from './../models/client';
import { ClientContact } from './../models/clientContact';
import { ModuleList } from './../models/module-list';
import { ClientServices } from './client.services';

@Injectable()
export class ClientListResolver {
    constructor(private backend: ClientServices) { }
    resolve(): Observable<Client[]> {
        return this.backend.getAllClients();
    }
}
@Injectable()
export class ClientListByBusinessResolver {
    constructor(private backend: ClientServices) { }
    resolve(): Observable<Client[]> {
        return this.backend.getAllClientsByBusiness();
    }
}

@Injectable()
export class ClientEditResolver {
    constructor(private backend: ClientServices) { }
    resolve(route: ActivatedRouteSnapshot): Observable<Client[]> {
        return this.backend.getClientById(+route.params['cid'])
    }
}
@Injectable()
export class ModuleListResolver {
    constructor(private backend: ClientServices) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ModuleList[]> {
        return this.backend.getModuleList(+route.params['cid'])
    }
}

@Injectable()
export class ClientContactListResolver {
    constructor(private backend: ClientServices) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ClientContact[]> {
        return this.backend.getClientContactByContactId(+route.params['cid']);
    }

}
@Injectable()
export class CountryCodeResolver {
    constructor(private backend: ClientServices) { }
    resolve(): Observable<any[]> {
        return this.backend.getCountryCode();
    }
}

